import { useContext } from "react";
import { PermissionContext } from "../contexts/PermissionProvider";

// What the signed-in user may do: { loading, error, all, can(key | [keys]), reload } - inside <PermissionProvider>.
// Outside of it (a page rendered alone) everything is allowed.
const ALLOW_ALL = { loading: false, error: false, all: true, can: () => true, reload: () => {} };

const usePermission = () => useContext(PermissionContext) || ALLOW_ALL;

export default usePermission;
